import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import ResendVerification from '../components/ResendVerification';
import styles from './LoginPage.module.css';

const EmailVerificationNotice = () => {
  const location = useLocation();
  const resendVerificationToken = location.state?.resendVerificationToken || '';
  const email = location.state?.email || '';

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>仮登録が完了しました</h2>
      <p>ご登録ありがとうございます。</p>

      <p>
        ご入力いただいたメールアドレス宛に「確認メール」を送信いたしました。<br />
        メールに記載された認証リンクをクリックして、登録を完了させてください。
      </p>

      {email && <p>送信先: {email}</p>}

      <ResendVerification token={resendVerificationToken} />

      {!resendVerificationToken && (
        <p>
          認証メールが見つからない場合は、<Link to="/login">ログイン画面</Link>から再送できます。
        </p>
      )}
    </div>
  );
};

export default EmailVerificationNotice;
